<template><div><h1>VUX V2.1.0Rc.51 发布日志</h1>
<h2><a href="/zh-CN/components/x-input.html">XInput</a></h2>
<ul><li>[fix] 修复`slots`判断问题 #936 @zscumt123</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.0Rc.51 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.0-rc.51-202.vue?e1f191b2